const navs = [
    {
        name: "labels.containers-by-percentage",
        url: "/reports/containers-picked-up/",
        icon: "clipboard-list",
        role: "tech",
    },
    {
        name: "labels.historic-containers",
        url: "/reports/containers-picked-up/graph/",
        icon: "fa-chart-line",
        role: "tech",
        type: "bridget",
    },
    {
        name: "labels.performance",
        url: "/reports/performance/",
        icon: "clipboard",
        role: "tech",
    },
    {
        name: "labels.analyses-collected",
        url: "/reports/collections-analysis/",
        icon: "truck-field",
        role: "tech",
    },
    {
        name: "labels.programming",
        url: "/reports/programing",
        icon: "clipboard",
        role: "admin",
    },
];
/*
    {
        name: "labels.executive",
        url: "/reports/executive/",
        icon: "chart-simple",
        role: "tech",
    },

  {name: "labels.alerts", url: "/reports/alerts/", icon: "clipboard"},
  {name: "labels.routes", url: "/reports/routes/", icon: "clipboard"}
* */

export default navs;
